<template>
    <div>
        <mainone :mainonebread="mainonebread"></mainone>
        <maintwo
            :maintwoiconshow="maintwoiconshow"
            :maintwoforminfo="maintwoforminfo"
            :myinputoneisshow="maintwoforminfo.myinputoneisshow"
            :myinputone="maintwoforminfo.myinputone"
            :myselectleftisshow="maintwoforminfo.selectleftisshow"
            :myselectleft="maintwoforminfo.selectleft"
            :myselecttopisshow="maintwoforminfo.selecttopisshow"
            :myselecttop="maintwoforminfo.selecttop"
            :myinputishow="myinputishow"
            :myinput="myinput"
            :myinputonefullisshow="maintwoforminfo.myinputonefullisshow"
            :myinputonefull="maintwoforminfo.myinputonefull"
            :myselectisshow="myselectisshow"
            :myselect="myselect"
            :myselectuptopisshow="myselecttopisshow"
            :myselectuptop="myselecttop"
            :myselectcityisshow="myselectcityisshow"
            :myselectcity="myselectcity"
            v-on:getsearchinfo="getSeachinfoEvent"
            v-on:searchForm="searchFormEvent"
        ></maintwo>
        <!--table表单-->
        <div>
            <!--主list列表-->
            <div style="margin-top: 10px; background-color: #ffffff; border-radius: 4px; line-height: 40px; padding: 0 20px">
                <div style="line-height: 60px">
                    <!--左侧名称-->
                    <div style="float: left; font-size: 14px">数据列表</div>
                    <div style="float: left; font-size: 14px; color: red; margin-left: 50px"></div>
                    <!--右侧按钮-->
                    <div style="float: right">
                        <!--自定义按钮-点击出现弹框&点击跳转子类页面@click="routeraddrClick('/XX路由')"-->
                        <!--1、点击出现弹框@click="addTanClick(XX弹框配置信息,dialogVisible = true);resetFormSenior(XXform表单)"-->
                        <!--2、点击跳转子类页面@click="routeraddrClick('/XX路由')-->
                        <!--<el-button ></el-button>-->
                        <!--导出按钮-点击导出数据-->
                        <el-button type="warning" plain @click="exportDatas()">导出</el-button>
                    </div>
                </div>

                <div>
                    <!--table表单-->
                    <el-table
                        :header-cell-style="{ background: '#F5F7FA' }"
                        ref="multipleTable"
                        :row-class-name="tableRowClassName"
                        :data="mainthreetableData.slice((currentPage - lastpage) * PageSize, currentPage * PageSize)"
                        style="width: 100%"
                        min-height="900"
                        border
                        v-loading="loading"
                        element-loading-text="正在飞速加载中..."
                        @selection-change="handleSelectionChange"
                        @cell-click="handleOneData"
                    >
                        <!--多选框-用于用户选择性导出数据-->
                        <el-table-column type="selection" width="55" v-if="mainthreeisshowset" />
                        <el-table-column
                            v-for="(mytabletitle, i) in mainthreetabletitle"
                            :key="i"
                            :fixed="mytabletitle.fixedstatu"
                            :prop="mytabletitle.prop"
                            :label="mytabletitle.label"
                            :width="mytabletitle.width"
                        >
                            <!--这里先通过table列表中的title值进行判断，在进行渲染展示-->
                            <!--例如：status状态字段，判断最终的值是那种表现形式等-->
                            <template #default="scope" v-if="mytabletitle.prop === 'thirdparty'">
                                <!-- 平台来源-数据渲染 -->
                                <div v-if="mytabletitle.prop === 'thirdparty'">
                                    <div>
                                        <span>{{ this.platforms.filter((n) => n.value == scope.row.thirdparty)[0].label }}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页器-->
                    <div class="block" style="text-align: center; margin: 30px 0">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="pageSizes"
                            :page-size="PageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mainone from '@/components/Mainone'
import maintwo from '@/components/Maintwo'
import componentProperties from '@/assets/js/componentProperties' // 公共数据
// import { ElMessage } from "element-plus";
import axios from 'axios'
import { defineComponent, ref } from 'vue'

export default defineComponent({
    name: 'vstatementdetails',
    data() {
        return {
            mainonebread: [
                {
                    name: '财务'
                },
                {
                    name: '对账单明细',
                    path: '/statementdetails'
                }
            ], // 当前页-【面包屑导航】
            maintwoiconshow: true, // 筛选-【高级筛选按钮】
            maintwoforminfo: {
                myinputoneisshow: true, //筛选查询-左侧字+input
                myinputone: {
                    divinterval: '0', //框右侧距离
                    titlewidth: '74px', //标题宽度
                    inputwidth: '200px', //input宽度
                    inputinterval: '20px', //input右侧距离
                    input: [
                        {
                            ismust: false, //是否必填，true表示必填
                            title: '输入搜索：',
                            placeholder: '订单编号',
                            name: 'trade_no',
                            content: ''
                        }
                    ]
                },
                selectleftisshow: true, //筛选查询-左侧字+select单框||select时间（放input框之后）
                selectleft: {
                    width: 'none',
                    divinterval: '', //框右侧距离
                    selectwidth: '200px',
                    selectinterval: '20px', //select右侧距离
                    select: [
                        {
                            selectisshow: true,
                            ismust: false,
                            title: '类型：',
                            placeholder: '全部',
                            name: 'type',
                            value: '',
                            options: [
                                {
                                    label: '全部',
                                    value: '0'
                                },
                                {
                                    label: '打印入账',
                                    value: '1'
                                },
                                {
                                    label: '打印退款',
                                    value: '2'
                                },
                                {
                                    label: '余额提现',
                                    value: '3'
                                },
                                {
                                    label: '商城入账',
                                    value: '4'
                                },
                                {
                                    label: '打印入账',
                                    value: '5'
                                },
                                {
                                    label: '打印退款',
                                    value: '6'
                                },
                                {
                                    label: '余额提现',
                                    value: '7'
                                },
                                {
                                    label: '商城入账',
                                    value: '8'
                                },
                                {
                                    label: '打印入账',
                                    value: '9'
                                },
                                {
                                    label: '打印退款',
                                    value: '10'
                                }
                            ]
                        },
                        {
                            selectisshow: true,
                            ismust: false,
                            title: '支付方式：',
                            placeholder: '全部',
                            name: 'paytype',
                            value: '',
                            options: [
                                {
                                    label: '全部',
                                    value: '0'
                                },
                                {
                                    label: '余额',
                                    value: '1'
                                },
                                {
                                    label: '微信',
                                    value: '2'
                                },
                                {
                                    label: '支付宝',
                                    value: '3'
                                },
                                {
                                    label: '其他',
                                    value: '4'
                                }
                            ]
                        }
                    ]
                }
            }, // 筛选-【筛选查询】-控件信息
            mainthreeisshowbut: false, // 数据列表中-【添加按钮】
            mainthreeisshowset: false, // 数据列表中-复选框
            mainthreeisshowope: false, // 数据列表中-操作-根据页面显示模块（整页）
            mainthreetableope: 33, // 数据列表中-操作-根据页面显示控件（整页）
            mainthreehandle: 180, // 数据列表中-操作-宽度
            mainthreetabletitle: [
                {
                    fixedstatu: 'left',
                    prop: 'trade_no',
                    label: '订单编号',
                    width: '250'
                },
                {
                    fixedstatu: false,
                    prop: 'client',
                    label: '设备编号',
                    width: '140'
                },
                {
                    fixedstatu: false,
                    prop: 'addtime',
                    label: '入账时间',
                    width: '200'
                },
                {
                    fixedstatu: false,
                    prop: 'type',
                    label: '类型',
                    width: '200'
                },
                {
                    fixedstatu: false,
                    prop: 'pay_uid',
                    label: '支付用户ID',
                    width: '200'
                },
                {
                    fixedstatu: false,
                    prop: 'is_in',
                    label: '收支类型',
                    width: ''
                },
                {
                    fixedstatu: false,
                    prop: 'price',
                    label: '金额',
                    width: ''
                },
                {
                    fixedstatu: false,
                    prop: 'credit',
                    label: '未提现余额',
                    width: ''
                },
                {
                    fixedstatu: false,
                    prop: 'paytype',
                    label: '支付方式',
                    width: ''
                },
                {
                    fixedstatu: false,
                    prop: 'thirdparty',
                    label: '平台来源',
                    width: ''
                }
            ], // 数据列表中-数据表头
            mainthreestatus: true, // 数据列表中-属于search按钮表示状态
            mainthreetableData: [], // 数据列表中-具体数据
            totalCount: 1, //数据列表中-数据总条数
            currentpage: 1, //数据列表中-数据当前页数
            lastpage: 1, //数据列表中-数据总页数（默认以20条一页）
            loading: false, //初始化-loading加载动效，默认是false关闭

            //高级筛选
            myinputishow: true, //高级筛选-input单框
            myinput: {
                divinterval: '3%', //框右侧距离
                inputwidth: '47%',
                inputmaxwidth: '100%',
                input: [
                    {
                        ismust: false, //是否必填，true表示必填
                        title: '输入搜索：',
                        placeholder: '订单编号',
                        name: 'trade_no',
                        content: ''
                    }
                ]
            },
            myselectisshow: true, //高级筛选-select单框
            myselect: {
                divinterval: '3%', //框右侧距离
                selectwidth: '47%',
                selectmaxwidth: '100%',
                select: [
                    {
                        selectisshow: true,
                        ismust: false,
                        title: '类型:',
                        placeholder: '全部',
                        name: 'type',
                        value: '',
                        options: [
                            {
                                label: '全部',
                                value: '0'
                            },
                            {
                                label: '打印入账',
                                value: '1'
                            },
                            {
                                label: '打印退款',
                                value: '2'
                            },
                            {
                                label: '余额提现',
                                value: '3'
                            },
                            {
                                label: '商城入账',
                                value: '4'
                            },
                            {
                                label: '打印入账',
                                value: '5'
                            },
                            {
                                label: '打印退款',
                                value: '6'
                            },
                            {
                                label: '余额提现',
                                value: '7'
                            },
                            {
                                label: '商城入账',
                                value: '8'
                            },
                            {
                                label: '打印入账',
                                value: '9'
                            },
                            {
                                label: '打印退款',
                                value: '10'
                            }
                        ]
                    },
                    {
                        selectisshow: true,
                        ismust: false,
                        title: '支付方式:',
                        placeholder: '全部',
                        name: 'paytype',
                        value: '',
                        options: [
                            {
                                label: '全部',
                                value: '0'
                            },
                            {
                                label: '余额',
                                value: '1'
                            },
                            {
                                label: '微信',
                                value: '2'
                            },
                            {
                                label: '支付宝',
                                value: '3'
                            },
                            {
                                label: '其他',
                                value: '4'
                            }
                        ]
                    },
                    {
                        selecttimeduanisshow: true, //该字段表示时间段模块状态：且已写死（字段名不可修改!）
                        ismust: false,
                        title: '入账时间区间：',
                        placeholder: {
                            placeholderstart: '请选择开始时间',
                            placeholderend: '请选择结束时间'
                        },
                        name: 'addtime',
                        value: {
                            valuestart: ref(''),
                            valueend: ref(''),
                            endstatus: true
                        },
                        rangeseparator: '至', //分隔符
                        divinterval: '3%', //上方字中-框右侧距离
                        selectwidth: '100%', //上方字中-总框长度
                        selectmaxwidth: '97%', //时间段-最大宽度
                        marginright: '0' //与右侧距离
                    }
                ]
            },

            // 平台来源下拉
            platforms: componentProperties.get('thirdpartyoption').options,

            // 支付方式-维护字段
            paytypeinfo: {},

            //分页
            currentPage: 1,
            pageSizes: [20, 50, 100],
            PageSize: 20,
            multipleSelection: [],
            thispagename: '', //通过路由获取当前页面的path值

            mytoken: localStorage.getItem('token'), //获取存储的token
            pagesdatas: [] //存储最近一次的筛选条件，供分页使用
        }
    },
    setup() {},
    mounted() {
        //获取当前页面路由path值
        this.thispagename = this.$route.path
    },
    methods: {
        //table表单-点击单位格-带参跳转等
        handleOneData(row, column, cell, event) {
            // console.log(row); //获取当前行数据
            // console.log(column); //获取当前单位格信息 ，通过column.property可获取当前单元的title得name值
            // console.log(event); //获取当前指针事件
            console.log(event.path[1].id) //获取当前指针所指向的单元格id值，配合标签的id使用
        },
        //table表-操作中-删除按钮（函数）
        deleteRow(index, rows) {
            //在table表中删除当前行信息，而rows.splice(index, 1)仅属于前端删除，可配合后具体操作
            rows.splice(index, 1)
        },
        //table表中-当选项发生变化是触发该函数
        handleSelectionChange(val) {
            console.log('this is:' + val)
            this.multipleSelection = val
        },
        //分页器中-当选择条数时触发该函数
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`)
            this.PageSize = val
            this.currentPage = 1

            //加载loading
            this.loading = true
            //通过Ajax向后台获取数据
            axios
                .post(
                    '/shop/fund/billInfo',
                    {
                        trade_no: this.pagesdatas.trade_no,
                        type: this.pagesdatas.type,
                        paytype: this.pagesdatas.paytype,
                        addtime: this.pagesdatas.addtime,
                        page: 1,
                        page_size: val
                    },
                    {
                        headers: {
                            Authen: localStorage.getItem('token')
                        }
                    }
                )
                .then((response) => {
                    this.myaxiosfunc(response.data.result)
                })
                .catch(function (error) {
                    // 请求失败处理
                    console.log(error)
                })
        },
        //分页器中-当选择分页时触发该函数
        handleCurrentChange(val) {
            console.log(`当前页: 第${val}页`)
            this.currentPage = val

            //加载loading
            this.loading = true
            //通过Ajax向后台获取数据
            axios
                .post(
                    '/shop/fund/billInfo',
                    {
                        trade_no: this.pagesdatas.trade_no,
                        type: this.pagesdatas.type,
                        paytype: this.pagesdatas.paytype,
                        addtime: this.pagesdatas.addtime,
                        page: val,
                        page_size: this.PageSize
                    },
                    {
                        headers: {
                            Authen: localStorage.getItem('token')
                        }
                    }
                )
                .then((response) => {
                    this.myaxiosfunc(response.data.result)
                })
                .catch(function (error) {
                    // 请求失败处理
                    console.log(error)
                })
        },
        //table表中-表格带状态-可扩展
        tableRowClassName({ rowIndex }) {
            //隔行显示
            if ((rowIndex + 1) % 2 === 0) {
                return 'warning-row'
            }
            return ''
        },
        //点击按钮-弹出弹框并赋值弹窗基本配置
        addTanClick(taninfo) {
            console.log(taninfo)
            this.tancontent.content = taninfo.content
            this.tancontent.title = taninfo.title
        },
        //点击进行路由页面跳转以及携带参数
        routeraddrClick(routeraddr) {
            this.$router.push(routeraddr).catch((error) => error)
        },
        //导出数据
        exportDatas() {
            axios
                .post(
                    '/shop/fund/billInfo',
                    {
                        trade_no: this.pagesdatas.trade_no,
                        type: this.pagesdatas.type,
                        paytype: this.pagesdatas.paytype,
                        addtime: this.pagesdatas.addtime,
                        export: 1
                    },
                    {
                        headers: {
                            Authen: localStorage.getItem('token')
                        }
                    }
                )
                .then((response) => {
                    console.log(response.data.message)
                    //   ElMessage({ type: "success", message: response.data.message });
                })
                .catch(function (error) {
                    // 请求失败处理
                    console.log(error)
                })
        },

        //提交等相关event事件函数
        //获取Container-Pagedata-Maintwo-高级筛选-开始检索返回的数据
        searchFormEvent(data) {
            console.log('高级筛选-开始检索返回数据(页面):' + JSON.stringify(data))
            //加载loading
            this.pagesdatas = data //将筛选条件赋值给本页的pagesdatas存储，供分页使用
            //加载loading
            this.loading = true
            //判断-申请时间段状态
            var getaddtime = null
            if (data.addtime.start == '') {
                getaddtime = ''
            } else {
                if (data.addtime.end == '') {
                    getaddtime = data.addtime.start + ' ~ ' + (data.addtime.start + 86400 - 1)
                } else {
                    getaddtime = data.addtime.start + ' ~ ' + (data.addtime.end + 86400 - 1)
                }
            }
            this.pagesdatas.addtime = getaddtime
            //通过Ajax向后台获取数据
            axios
                .post(
                    '/shop/fund/billInfo',
                    {
                        trade_no: data.trade_no,
                        type: data.type,
                        paytype: data.paytype,
                        addtime: getaddtime,
                        page: 1,
                        page_size: this.PageSize
                    },
                    {
                        headers: {
                            Authen: localStorage.getItem('token')
                        }
                    }
                )
                .then((response) => {
                    this.myaxiosfunc(response.data.result)
                })
                .catch(function (error) {
                    // 请求失败处理
                    console.log(error)
                })
        },
        //获取Container-Pagedata-Maintwo-搜索-返回的数据
        getSeachinfoEvent(data) {
            console.log('点击查询获取的data数组：' + JSON.stringify(data))
            this.pagesdatas = data //将筛选条件赋值给本页的pagesdatas存储，供分页使用
            //加载loading
            this.loading = true
            //通过Ajax向后台获取数据
            axios
                .post(
                    '/shop/fund/billInfo',
                    {
                        trade_no: data.trade_no,
                        type: data.type,
                        paytype: data.paytype,
                        page: 1,
                        page_size: this.PageSize
                    },
                    {
                        headers: {
                            Authen: localStorage.getItem('token')
                        }
                    }
                )
                .then((response) => {
                    this.myaxiosfunc(response.data.result)
                })
                .catch(function (error) {
                    // 请求失败处理
                    console.log(error)
                })
        },
        //数据渲染
        myaxiosfunc(successdata) {
            var newdata = successdata.data
            for (var i = 0; i < newdata.length; i++) {
                // 入账时间-渲染
                if (newdata[i].addtime) {
                    if (newdata[i].addtime === 0 || newdata[i].addtime === null) {
                        newdata[i].addtime = '无支付时间'
                    } else {
                        newdata[i].addtime = this.$utils.formatDate(newdata[i].addtime)
                    }
                } else {
                    newdata[i].addtime = '无支付时间'
                }
                // 类型-渲染 - console.log(this.myselect.select[0].options[newdata[i].type]) [频繁加载易出现异步现象-待优化]
                if (newdata[i].type) {
                    this.myselect.select[0].options.forEach((element) => {
                        if (newdata[i].type == element.value) {
                            newdata[i].type = element.label
                        }
                    })
                } else {
                    newdata[i].type = '---'
                }
                // 收支类型-渲染
                if (newdata[i].is_in) {
                    newdata[i].is_in = newdata[i].is_in == 1 ? '支出' : '收入'
                } else {
                    newdata[i].is_in = '---'
                }
                // 支付方式-渲染
                if (newdata[i].paytype) {
                    this.myselect.select[1].options.forEach((element) => {
                        if (newdata[i].paytype == element.value) {
                            newdata[i].paytype = element.label
                        }
                    })
                } else {
                    newdata[i].paytype = '---'
                }
            }
            // console.log('当前页面的data:' + JSON.stringify(newdata))
            this.mainthreetableData = newdata
            this.totalCount = successdata.total
            this.currentpage = successdata.current_page //当前页面页数
            this.lastpage = successdata.last_page
            this.loading = false
        },

        // 获取-类型-下拉内容
        getconfiginfotype(configinfo) {
            //获取api-加载类型信息（根据API返回的json数据结构不同，函数方法不同！）
            var alldatas = Array()
            var num = 0
            alldatas[num] = { value: num, label: '全部' }
            for (var key in configinfo) {
                num = num + 1
                alldatas[num] = { value: key, label: configinfo[key] }
            }
            //这里的select[0],是写死的，后续可优化！注意写死的状况下，select的位置不可移动
            this.maintwoforminfo.selectleft.select[0].options = alldatas
            this.myselect.select[0].options = alldatas
        },
        // 获取支付方式-下拉内容
        getpaytype(configinfo) {
            //获取api-加载类型信息（根据API返回的json数据结构不同，函数方法不同！）
            var alldatas = Array()
            var num = 0
            alldatas[num] = { value: num, label: '全部' }
            for (var key in configinfo) {
                num = num + 1
                alldatas[num] = { value: key, label: configinfo[key] }
            }
            //这里的select[0],是写死的，后续可优化！注意写死的状况下，select的位置不可移动
            this.maintwoforminfo.selectleft.select[1].options = alldatas
            this.myselect.select[1].options = alldatas
        }
    },
    created() {
        if (localStorage.getItem('token') === null || !localStorage.getItem('token')) {
            this.isshow = false
            this.$router.push('/').catch((error) => error)
        } else {
            //获取类型 -配置
            axios
                .post(
                    '/shop/user/configInfo',
                    {
                        key_name: 'cashflow_shop_type'
                    },
                    {
                        headers: {
                            Authen: localStorage.getItem('token')
                        }
                    }
                )
                .then((response) => {
                    this.getconfiginfotype(response.data.result)
                })
                .catch(function (error) {
                    console.log(error)
                })

            // 获取支付方式-配置
            axios
                .post(
                    '/shop/user/configInfo',
                    {
                        key_name: 'cashflow_shop_paytype'
                    },
                    {
                        headers: {
                            Authen: localStorage.getItem('token')
                        }
                    }
                )
                .then((response) => {
                    this.getpaytype(response.data.result)
                    this.paytypeinfo = response.data.result
                })
                .catch(function (error) {
                    console.log(error)
                })

            //加载loading
            this.loading = true //通过Ajax向后台获取数据

            // 判断-是否带参数进入
            this.pagesdatas = {
                page: 1,
                page_size: this.PageSize
            }
            // 判断-路由携带-跳转数据
            let routerinfo = this.$route.query
            if (routerinfo.id) {
                if (routerinfo.month) {
                    this.pagesdatas = {
                        addtime: this.$route.query.month,
                        page: 1,
                        page_size: this.PageSize
                    }
                }
                if (routerinfo.day) {
                    this.pagesdatas = {
                        addtime: this.$route.query.day,
                        page: 1,
                        page_size: this.PageSize
                    }
                }
            }
            //通过Ajax向后台获取数据
            axios
                .post('/shop/fund/billInfo', this.pagesdatas, {
                    headers: {
                        Authen: localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    this.myaxiosfunc(response.data.result)
                })
                .catch(function (error) {
                    console.log(error)
                })
        }
    },
    components: {
        mainone,
        maintwo
    }
})
</script>

<style scoped>
/*操作中-按钮样式*/
.el-button--mini {
    min-height: 28px;
    padding: 0 8px;
    font-size: 12px;
    border-radius: calc(var(--el-border-radius-base) - 1px);
}
</style>
